<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: [String, Number],
    },
    disabled: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    rules: {
      type: String,
    },
  },
  data() {
    return {
      innerValue: this.value || '',
    }
  },
  watch: {
    innerValue: function (v) {
      this.$emit('input', v)
    },
    value(value) {
      if (this.innerValue !== value) this.innerValue = value
    }
  },
  computed: {
    textPlaceholder() {
      return this.required && !this.label ? `${this.placeholder} *` : this.placeholder
    },
    inputListeners() {
      // https://v2.vuejs.org/v2/guide/components-custom-events#Binding-Native-Events-to-Components
      const vm = this
      return Object.assign(
        {},
        this.$listeners,
        {
          input(event) {
            vm.$emit('input', event.target.value)
          }
        }
      )
    },
  },
}
</script>

<template>
  <ValidationProvider :rules="rules" v-slot="{ errors, passed, failed }">
    <div class="classic-form__textarea">
      <label v-if="label">
        {{ label }}&nbsp;
        <svg v-if="required" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.71733 5.86375L2.81179 3.76574L1.0419 4.90423L0.5 3.95963L2.37926 3.00011L0.5 2.04059L1.0419 1.09599L2.81179 2.23449L2.71733 0.136475H3.79616L3.7017 2.23449L5.47159 1.09599L6.01349 2.04059L4.13423 3.00011L6.01349 3.95963L5.47159 4.90423L3.7017 3.76574L3.79616 5.86375H2.71733Z"
            fill="#E12121" />
        </svg>
      </label>
      <textarea
        v-bind="$attrs"
        v-on="inputListeners"
        v-model="innerValue"
        :data-passed="(passed && innerValue !== '') || Boolean(innerValue)"
        :data-failed="failed"
        :placeholder="textPlaceholder"
        :disabled="disabled"
        :readonly="readonly"
        :required="required"
      ></textarea>
      <span v-if="errors[0]" class="classic-form__textarea__error-message scroll-to-error-message">{{ errors[0] || '' }}</span>
    </div>
  </ValidationProvider>
</template>

<style lang="scss" scoped>
.classic-form__textarea {
  display: flex;
  flex-direction: column;

  textarea {
    position: relative;
    min-height: 180px;
    width: 100%;
    padding: 12px 15px;
    background-color: #FDFDFF;
    outline: 2px solid #DADADA !important;
    outline-offset: -2px !important;
    border: none !important;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.01em;
    resize: vertical;
    word-break: break-all;

    &::placeholder {
      color: #6C7E95;
    }

    &:focus {
      border: none !important;
      outline-color: #2E47BA !important;

      &::placeholder {
        color: transparent;
      }
    }

    &[data-failed=true] {
      outline-color: #E12121 !important;
    }
  }

  label {
    display: flex;
    align-items: center;
    color: #203551 !important;
    font-weight: 500 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: -0.01em !important;
    margin-bottom: 4px !important;
  }

  &__error-message {
    margin-top: 3px;
    display: inline-block;
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #E12121;
  }

  .scroll-to-error-message {
    scroll-margin: 212px;
  }
}
</style>